export default __webpack_public_path__ + "static/media/section-two.e02c196d2dc85d7720ea955a782fc12b.svg";